import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PROJECTS } from "../data/content";
import Seo from "../components/Seo";

export default function Projects() {
  return (
    <div data-testid="page-projects">
      <Seo
        title="Projects — Bush Botanics, Growing Country, Training and more"
        description="Bush Botanics in the Central Desert, Growing Country, national seed-system advisory work and on-Country training — projects we are building, supporting and learning from."
        path="/projects"
      />
      <section className="border-b border-rule">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28">
          <p className="section-num mb-4">Projects — Field Record</p>
          <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[0.98] max-w-4xl">
            Where the work is happening — and what we've learned.
          </h1>
          <p className="mt-8 max-w-2xl text-base md:text-lg text-ink/85 leading-relaxed">
            We believe credibility is earned through experience, not
            presentations. These are the projects we are building, supporting,
            advising, or learning from. Some are emerging. All are grounded in
            real work on Country.
          </p>
        </div>
      </section>

      <section>
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28 grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-14">
          {PROJECTS.map((p, idx) => {
            const Wrapper = p.link ? Link : "article";
            const wrapperProps = p.link
              ? { to: p.link, className: "group card-lift bg-card border border-rule block hover:shadow-[6px_6px_0_#D49A44]" }
              : { className: "group card-lift bg-card border border-rule" };
            return (
              <Wrapper key={p.name} {...wrapperProps} data-testid={`project-card-${idx}`}>
                <div className="relative overflow-hidden">
                  <img src={p.image} alt={p.name} className="w-full h-72 md:h-80 object-cover" />
                  <div className="absolute top-4 left-4 bg-cream/90 border border-rule px-3 py-1 specimen-label">
                    No. {String(idx + 1).padStart(2, "0")} · {p.region}
                  </div>
                </div>
                <div className="p-6 md:p-8">
                  <div className="flex items-start justify-between gap-4">
                    <h2 className="font-serif text-2xl md:text-3xl leading-tight mb-3">{p.name}</h2>
                    {p.link && <ArrowUpRight size={20} className="text-eucalypt mt-1 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />}
                  </div>
                  <p className="text-sm text-ink/80 leading-relaxed">{p.body}</p>
                  {p.link && (
                    <span className="mt-5 inline-block link-mono text-eucalypt">Explore this program</span>
                  )}
                </div>
              </Wrapper>
            );
          })}
        </div>
      </section>
    </div>
  );
}
